<button
  type="button"
  class="btn btn-secondary d-flex align-items-center gap-2"
  ngbTooltip="Save problem report will collect files from the system and devices, initiating the file-saving process."
  placement="auto"
  container="body"
  [openDelay]="450"
  [disabled]="problemReportSavingRunning$ | async"
  (click)="onSaveProblemReport()"
>
  <i class="bi-file-earmark-arrow-down-fill"></i>
  <span class="d-none d-xxxl-inline text-nowrap">SAVE PROBLEM REPORT</span>
</button>
